import { Grid } from '@mui/material'
// import { Login1Icon } from 'components/ui-kit/icons/iconComponents/Login1Icon'
import CustomButton from 'components/ui-kit/Button/index'
import CustomTextField from 'components/ui-kit/TextField'
import CustomTypography from 'components/ui-kit/Typography/index'
import { LOADER_TYPE } from 'utils/constants'
import { LoginContainer, LoginIconContainer, RootLoginContainer, WelcomeTextContainer } from './styles'
import { useLoginController } from './controller/useLoginController'
import AppLoader from 'components/ui-kit/AppLoader'
import logo from '../../../assets/images/Logo.png'

const Login = () => {
  const isOperator = window.location.pathname?.split('/')?.[1] === 'operator'

  const { t, otpRequired, otp, setOtp, handleSubmit, values, handleChange, errors, loginLoading } = useLoginController()
  return (
    <Grid className='loginBgWrap' container>
      <Grid item xs={12} lg={6} sx={{ position: 'relative' }}>
        <RootLoginContainer sx={{ flexDirection: 'column' }}>
          <Grid sx={{ flexDirection: 'column', gap: '10px', display: 'flex', alignItems: 'center' }}>
            <img src={logo} />
            <CustomTypography
              value={t('GammastackDemoPlatformLogin')}
              sx={{
                textAlign: 'center', marginBottom: '10px', fontWeight: '600', color: (theme) => theme.colors.black, fontSize: '30px'
              }}
            />
          </Grid>
          <LoginContainer className='loginContainer' sx={{ background: '#ffffff15', border: '1px solid #ffffff15', borderRadius: '25px' }}>
            {/* <CustomTypography
              value={isOperator ? t('operatorLogin') : t('login')}
              variant='h5'
              sx={{
                textAlign: 'center', marginBottom: '10px', fontWeight: '600', color: (theme) => theme.colors.black
              }}
            /> */}
            <br />
            <CustomTextField
              sx={{ marginBottom: '20px' }}
              label={t('email')}
              placeholder={t('email')}
              variant='outlined'
              fullWidth
              id='email'
              name='email'
              value={values.email}
              onChange={handleChange}
              error={errors.email}
              helperText={errors.email}
              enablevalidation={Boolean(values.email || errors.email)}
              className='loginInput'
            />
            <CustomTextField
              sx={{ marginBottom: '20px' }}
              label={t('password')}
              type='password'
              placeholder={t('password')}
              variant='outlined'
              name='password'
              id='password'
              value={values.password}
              onChange={handleChange}
              error={errors.password}
              helperText={errors.password}
              enablevalidation={Boolean(values.password || errors.password)}
              className='loginInput'
            />
            {isOperator &&
              <CustomTextField
                sx={{ marginBottom: '20px' }}
                label={t('operatorId')}
                placeholder={t('operatorId')}
                variant='outlined'
                fullWidth
                id='operatorId'
                name='operatorId'
                value={values.operatorId}
                onChange={handleChange}
                error={errors.operatorId}
                helperText={errors.operatorId}
                enablevalidation={Boolean(values.operatorId || errors.operatorId)}
              />}

            {otpRequired && (
              <CustomTextField
                label={t('Enter OTP')}
                variant='outlined'
                fullWidth
                id='otp'
                name='otp'
                type='number'
                value={otp}
                sx={{ letterSpacing: '10px' }}
                onChange={(e) => {
                  const value = e.target.value
                  String(value).length <= 6 && setOtp(value)
                }}
              />)}

            <CustomButton
              variant='contained'
              disabled={Boolean(errors.email) || Boolean(errors.password) || !values.email.length || loginLoading}
              onClick={handleSubmit}
              type='submit'
              sx={{ background: (theme) => theme.colors.btnBg2, minWidth: '266px', width: '100%' }}
            >
              {
                loginLoading
                  ? <AppLoader variant={LOADER_TYPE.PULSE} size={5} />
                  : <CustomTypography sx={{ fontWeight: 'bold' }} value={t('login')} />
              }
            </CustomButton>
          </LoginContainer>
        </RootLoginContainer>

        <LoginIconContainer>
          {/* <Login1Icon style={{ height: '100%', width: '100%' }} /> */}
        </LoginIconContainer>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: { xs: 'none', lg: 'block' },
          position: 'relative'
        }}
      >
        <WelcomeTextContainer>
          {/* <img src={logo} alt='logo' className='loginLogo' /> */}
        </WelcomeTextContainer>
      </Grid>
      <Grid item xs={12} textAlign='center' sx={{ position: 'fixed', width: '100%', bottom: '10px', left: '0' }} justifyContent='center'>
        <Grid style={{ display: 'flex', justifyContent: 'center' }}>
          <CustomTypography
            value={t('GammastackDemoPlatformRights')}
            sx={{
              textAlign: 'center', fontWeight: '600', color: (theme) => theme.colors.black, fontSize: '14px'
            }}
          />
          <CustomTypography
            value={t('GammastackDemoPlatform')}
            sx={{
              textAlign: 'center', marginLeft: '5px', fontWeight: '600', color: '#972e26', fontSize: '14px'
            }}
          />
        </Grid>
        <CustomTypography
          value={t('GamingProvider')}
          sx={{
            textAlign: 'center', fontWeight: '600', color: '#ffffff30', fontSize: '12px'
          }}
        />
      </Grid>
    </Grid>
  )
}

export default Login
